import { Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { useState } from "react";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { Lists } from "../../components/common/Lists";
import TableComponent from "../../components/common/Tables";
import { useAppDispatch } from "../../hooks/hooks";
import { useGetClassroomTypesQuery } from "../../hooks/useGetClassroomTypesQuery";
import { setClassroomTypeData } from "../../redux/slices/school/classroomType";
import { routes } from "../../routes";
import { updateClassRoomType } from "../../services/school/classroom/classroom";
import { ClassroomTypesType } from "../../types/Classroom";
import { Key_classroomtypes } from "../../utils/constants";
import { ConfirmAlertDialog } from "../../components/common/ConfirmAlertDialog";

const columnNamesMap: { [key: string]: string } = {
    description: 'Nome',
};
export const ClassroomTypes = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const queryClient = useQueryClient();
    const { data, status } = useGetClassroomTypesQuery({ PageNumber: currentPage, PageSize: 400 });
    const [deleteItem, setDeleteItem] = useState<ClassroomTypesType | null>(null);

    const openDeleteDialog = (s: ClassroomTypesType) => {
        setDeleteItem(s);
    };
    const confirmDelete = async () => {
        if (deleteItem) {
            await handleDelete(deleteItem!)
        }
    };
    const mutationUpdate = useMutation(updateClassRoomType, {
        onSuccess: () => {
            queryClient.invalidateQueries(Key_classroomtypes);
            toast.success('Tipo de sala apagada');
        },
        onError: () => {
            toast.error("Erro ao apagar tipo de sala.")
        }
    });

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };
    const handleClickCreate = (event: any): void => {
        navigate(routes.createClassroomType)
    }
    const handleEdit = (classroomType: ClassroomTypesType) => {
        dispatch(setClassroomTypeData(classroomType));
        navigate(routes.updateClassroomType)
    };
    const handleDelete = (classroomType: ClassroomTypesType) => {
        classroomType.status = false;
        mutationUpdate.mutateAsync(classroomType)
    };

    const options = data?.items.map((classroomType: ClassroomTypesType) => [
        {
            label: 'Editar',
            onClick: () => handleEdit(classroomType),
            icon: <Pencil1Icon />
        },
        {
            label: 'Excluir',
            onClick: () => openDeleteDialog(classroomType),
            icon: <TrashIcon />
        }
    ]) || [];

    return (
        <>
            <Lists
                status={status}
                TableComponent={() =>
                    <TableComponent
                        columns={Object.keys(columnNamesMap)}
                        items={data?.items}
                        options={options}
                        columnNamesMap={columnNamesMap}
                        totalPages={data?.totalPages || 1}
                        currentPage={currentPage}
                        onPageChange={handlePageChange}
                    />
                }
                handleClickCreate={handleClickCreate}
            />
            <ConfirmAlertDialog
                open={!!deleteItem}
                onOpenChange={(open) => !open && setDeleteItem(null)}
                title="Esta operação é irreversível"
                item={deleteItem}
                onConfirm={confirmDelete}
                onCancel={() => setDeleteItem(null)}
            />
        </>
    );
}